module.exports = __webpack_public_path__ + "img/20200103154431089.b745fc62.jpg";